/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFieldState } from 'informed';

function useNonSpammyFieldState<T extends any>(field: string): { value: T } {
  // eslint-disable-next-line prefer-destructuring
  const warn = console.warn;
  console.warn = () => {};
  const fieldState = useFieldState(field);
  console.warn = warn;

  return fieldState as unknown as { value: T };
}

export default useNonSpammyFieldState;
